/**
 * DeleteMemberForm functionality:
 * Since the checkbox is visually hidden, when the delete button is clicked, it checks the checkbox and then submits the form
 * @class
 */
export default class DeleteMemberForm {
    /**
     * @constructor
     * @param {HTMLElement} element The DeleteMemberForm root element
     */
    constructor(element) {
        var _a;
        this.el = element;
        this.components = {
            form: this.el.querySelector('form'),
            checkbox: this.el.querySelector('#confirm-checkbox'),
        };
        const deleteAccount = (event) => {
            var _a;
            event.preventDefault();
            if (this.components.checkbox != null) {
                this.components.checkbox.checked = true;
            }
            (_a = this.components.form) === null || _a === void 0 ? void 0 : _a.submit();
        };
        (_a = this.components.form) === null || _a === void 0 ? void 0 : _a.addEventListener('submit', deleteAccount);
        //console.log('DeleteMemberForm', this);
    }
    /**
     * Creates new instances of IDeleteMemberFormUtils for each `[data-component="DeleteMemberForm"]` element
     */
    static init() {
        const DeleteMemberFormEl = document.querySelector('[data-component="deleteMemberForm"]');
        if (DeleteMemberFormEl) {
            const DeleteMemberFormUtil = new DeleteMemberForm(DeleteMemberFormEl);
        }
    }
}
